<ion-list mode="ios" lines="none" class="list-content">
  <ion-item mode="md" color="white" lines="none" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="add-other-product mpe-font-weight-600"
    >
      {{ 'Labels.add-other-product' | translate }}
    </ion-label>
  </ion-item>

  <ion-item mode="md" color="white" lines="none">
    <ion-img class="cart-full" [src]="'Icons.cart-full' | translate"></ion-img>
  </ion-item>

  <ion-item mode="md" color="white" lines="none" class="ion-text-center">
    <ion-label
      mode="md"
      color="status-icon-enable"
      class="take-advantage-delivery"
    >
      {{ 'Labels.take-advantage-delivery' | translate }}
    </ion-label>
  </ion-item>

  <ion-item mode="md" color="white" lines="none" class="item-another">
    <ion-button
      class="button-another"
      size="default"
      mode="md"
      color="tpcta"
      (click)="onAnother()"
    >
      <ion-label mode="md">
        {{ 'Buttons.add-another-product' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>

  <ion-item mode="md" color="white" lines="none">
    <ion-button
      class="mpe-button-link-line button-continue"
      size="default"
      mode="md"
      fill="clear"
      color="darkblue"
      (click)="onContinue()"
    >
      <ion-label mode="md" color="darkblue">
        {{ 'Buttons.continue' | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
